export type BotChatMessageInput = {
  direction?: string | null;
  text?: string | null;
  intent_kind?: string | null;
  intent_source?: string | null;
  current_flow?: string | null;
  error?: string | null;
  llm_model?: string | null;
};

export type MessageBadge = {
  kind: 'intent' | 'source' | 'flow' | 'model';
  value: string;
};

export type MessageDisplay = {
  side: 'user' | 'bot';
  isError: boolean;
  isMediaOnly: boolean;
  text: string;
  badges: MessageBadge[];
};

/**
 * Pure: derive presentational props for a single bot-chat message.
 * Inbound = user->bot (left), outbound = bot->user (right). Intent/source/flow
 * badges apply to inbound turns only; llm_model badges apply to outbound
 * replies that actually called the LLM. Empty text means a media-only turn.
 */
export function deriveMessageDisplay(message: BotChatMessageInput): MessageDisplay {
  const side: 'user' | 'bot' = message.direction === 'outbound' ? 'bot' : 'user';
  const text = (message.text ?? '').trim();
  const badges: MessageBadge[] = [];

  if (side === 'user') {
    if (message.intent_kind) badges.push({ kind: 'intent', value: message.intent_kind });
    if (message.intent_source) badges.push({ kind: 'source', value: message.intent_source });
    if (message.current_flow) badges.push({ kind: 'flow', value: message.current_flow });
  }
  if (side === 'bot' && message.llm_model) {
    badges.push({ kind: 'model', value: message.llm_model });
  }

  return {
    side,
    isError: Boolean(message.error),
    isMediaOnly: text.length === 0,
    text,
    badges,
  };
}
